/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
// import Image from 'next/image';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';

import styles from './contentPage.module.scss';

import NextSeoWrapper from '@/components/NextSeoWrapper';
import PageContainer from '@/components/PageContainer';
import { getLanguageAlternates } from '@/utils/locale';
import { getCanonicalUrl } from '@/utils/navigation';

const path = '/history';
const HistoryPage = () => {
    const { t, lang } = useTranslation('history');


    return (
        <>
            <NextSeoWrapper
                title={t('common:history')}
                url={getCanonicalUrl(lang, path)}
                languageAlternates={getLanguageAlternates(path)}
            />
            <PageContainer>
                <div className={styles.historyPage}>
                    <h1 style={{ textAlign: 'center' }}>{t('history:al-faqar-chain')}</h1>
                    <h2 style={{ textAlign: 'center' }}>{t('history:include-alfaqar')}</h2>
                    <p>

                        <ul>
                            {Array.from({ length: 21 }, (_, index) => {
                                const i18nKey = `history:sultan.alfaqr-${index + 1}`;
                                // const isBold = index === 20;

                                return (
                                    <li className={styles.lineHeigh} key={index} >
                                        <Trans i18nKey={i18nKey} />
                                    </li>
                                );
                            })}
                        </ul>
                    </p>


                    <p className={styles.lineHeigh}>
                        {lang === 'ur' && (
                            <>
                                <span>
                                    <Trans
                                        i18nKey="history:parahgraph-0"
                                    />
                                </span>
                                    </>
                                )}
                                <span style={{ fontWeight: "bold" }}>
                                    <Trans
                                        i18nKey="history:sultan.alfaqr-22"
                                    />
                                </span>
                        <Trans
                            i18nKey="history:parahgraph-1"
                        />
                    </p>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="history:parahgraph-2"
                        />
                    </p>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="history:parahgraph-3"
                        />
                    </p>
                    <h1 style={{ textAlign: 'center' }}>{t('history:tafseer-quran')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="history:parahgraph-4"
                        />
                    </p>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="history:parahgraph-5"
                        />
                    </p>
                    <p className={styles.lineHeigh}>
                        <span style={{ fontWeight: "bold" }}>
                            <Trans
                                i18nKey="history:sultan.alfaqr-23"
                            />
                        </span>
                        <Trans
                            i18nKey="history:parahgraph-6"
                        />
                        {/* <br />
                        <span>www.alfaqr.com</span> */}
                    </p>
                    <h1 style={{ textAlign: 'center' }}>{t('history:publication')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="history:parahgraph-7"
                        />
                        <span style={{ fontWeight: "bold" }}>
                            <Trans
                                i18nKey="history:sultan.alfaqr-24"
                            />
                        </span>
                        <Trans
                            i18nKey="history:parahgraph-8"
                        />
                    </p>
                    <p>
                        <ul className={styles.decimal}>
                            {Array.from({ length: 7 }, (_, index) => (
                                <li className={styles.lineHeigh} key={index}>
                                    <Trans i18nKey={`history:publication-${index + 1}`} />
                                </li>
                            ))}
                        </ul>
                    </p>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="history:parahgraph-9"
                        />
                    </p>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="history:parahgraph-10"
                        />
                    </p>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="history:parahgraph-11"
                        />
                    </p>
                </div>
            </PageContainer>
        </>
    );
};

export default HistoryPage;
